import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { AddCall } from 'src/providers/addvCall';
import { PopupalertPage } from '../popupalert/popupalert.page';
import * as moment from 'moment';
import { VaccinepopupPage } from './vaccinepopup/vaccinepopup.page';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-vaccination-schedule',
  templateUrl: './vaccination-schedule.page.html',
  styleUrls: ['./vaccination-schedule.page.scss'],
})
export class VaccinationSchedulePage implements OnInit {
  presentView: any; titleValue: any; name: any; dob: any; showAddBtn: any; vaccineList: any; profileDtl: any[] = [];
  patientId: any; parentId: any; isChecked: boolean = true; slideOptsOne: any; swipdataone: any[] = []; swipdatatwo: any[] = [];
  recordId: any; patientdetails: any; gender: any; uniqueVaccineList: any[] = [];
  updatedData: any;
  programImage: any = [
    { id: 2, path: 'assets/iconvacci/first.png' },
    { id: 3, path: 'assets/iconvacci/second.png' },
    { id: 4, path: 'assets/iconvacci/third.png' },
    { id: 5, path: 'assets/iconvacci/fourth.png' },
    { id: 6, path: 'assets/iconvacci/sixth.png' },
    { id: 7, path: 'assets/iconvacci/one.png' },
    { id: 8, path: 'assets/iconvacci/oneHalf.png' },
    { id: 9, path: 'assets/iconvacci/two.png' },
    { id: 10, path: 'assets/iconvacci/threehalf.png' },
    { id: 11, path: 'assets/iconvacci/twelfth.png' },
    { id: 12, path: 'assets/iconvacci/eighteenth.png' }
  ];
  constructor(public service: ServicesProvider, public router: Router, public toastController: ToastController,
    public addCall: AddCall, public modalCtrl: ModalController, public activeRoute: ActivatedRoute,private datePipe: DatePipe,) { }

  ngOnInit() {
  }
  ionViewWillEnter() {
    this.titleValue = "Vaccination Schedule";
    this.patientId = this.activeRoute.snapshot.paramMap.get('patient_id')
    this.gender = this.activeRoute.snapshot.paramMap.get('gender')
    this.parentId = localStorage.getItem("patient_id")
    this.getInfantDetails();
  }

  addData() {
    this.presentView = "addView";
    this.titleValue = "Add Child";
  }

  addInfant() {
    let ageValue = this.ageValidation(this.dob);
    if (this.name == "" || this.name == undefined) {
      this.showToast("Please Enter Name");
    } else if (this.dob == "" || this.dob == undefined) {
      this.showToast("Please Enter DOB");
    } else if (ageValue == false) {

    } else {
      let apiData = {
        "infantName": this.name,
        "infantDob": formatDate(this.dob, "yyyy-MM-dd", "en-Us"),
        "infantParentId": localStorage.getItem("patient_id"),
        "profileImg": ""
      }
      this.service.postRequestGndrl("Patient/memberInfantInsert", apiData).subscribe(res => {
        if (res.status == 1) {
          this.showToast("Inserted successfully");
          this.getInfantDetails();
        }
      })
    }
  }

  back() {
    if (this.presentView == "ListView") {
      this.router.navigateByUrl("/tabs/profile");
    } else {
      this.presentView = "ListView";
      this.titleValue = "Vaccination Schedule";
    }
  }

  getInfantDetails() {
    debugger;
    let apiData = {
      "infantParentId": this.parentId,
      "patientId": this.patientId
    }
    this.service.postRequestGndrl("Patient/getMemberInfantDetails", apiData).subscribe(res => {
      this.profileDtl = [];
      this.swipdataone = [];
      this.swipdatatwo = [];
      this.showAddBtn = res.data.length > 0 ? false : true;
      this.vaccineList = res.data;
      let loopValue = false
      let datas = res.data
      datas.forEach(item => {
        item.patient_details = JSON.parse(item.patient_details);
      });

      console.log(datas);

      res.data.forEach(element => {
        if (element.is_completed == '0' && loopValue == false) {
          this.profileDtl.push(element);
          loopValue = true;
        }
      });
      console.log(this.profileDtl);
      console.log(this.vaccineList, '=======>', this.vaccineList.length);

      this.uniqueVaccineList = [];
      const seen = new Set();

      for (let i = 0; i <= this.vaccineList.length - 1; i++) {
        const vaccine = this.vaccineList[i];
        const uniqueKey = `${vaccine.infant_patient_id}-${vaccine.age_of_vaccination}`;
        if (!seen.has(uniqueKey)) {
          seen.add(uniqueKey);
          this.uniqueVaccineList.push(vaccine);
        }
      }
      console.log("uniqueVaccineList", this.uniqueVaccineList);

      // Create a map from programImage for easy lookup
      const programImageMap = new Map(this.programImage.map(item => [item.id, item.path]));

      // Update the icon_path in data based on the year_id matching the id in programImage
      this.updatedData = this.uniqueVaccineList.map(item => {
        const newPath = programImageMap.get(Number(item.year_id));
        return {
          ...item,
          icon_path: newPath || item.icon_path // use the new path if found, otherwise keep the existing path
        };
      });

      console.log(this.updatedData);

      // for (let i = 0; i <= this.vaccineList.length - 1; i++) {
      //   if (i + 1 == this.vaccineList[i].id && i <= 5) {
      //     this.swipdataone.push(this.vaccineList[i]);
      //   } else if ((i + 1 == this.vaccineList[i].id && i > 5 && i < 12)) {
      //     this.swipdatatwo.push(this.vaccineList[i]);
      //   }
      // }
      // console.log("this.swipdataone", this.swipdataone);
      // console.log("this.swipdatatwo", this.swipdatatwo);

      this.presentView = "ListView";
    })
  }

  async showToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 1000,
      position: 'bottom',
      color: 'dark'
    });

    await toast.present();
  }

  getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  ageValidation(ageString) {
    let age = this.getAge(ageString);
    if (age > 18) {
      this.showToast("Age should be less then 18");
      return false;
    }
    return true;
  }

  scheduleUpdate(index, type, event) {
    let datas;
    let dataone;
    const checkPreviousCompleted = (data, currentIndex) => {
      for (let i = 0; i < currentIndex; i++) {
        if (data[i].is_completed == "0") {
          datas = data[i]
          console.log("datas", datas);
          return false;
        }
      }
      return true;
    };
    // const checkPreviousCompleteds = (data, currentIndex) => {
    //   for (let i = 0; i <= currentIndex; i++) {
    //     if (data[i].is_completed == "0") {
    //       dataone = data[i]
    //       console.log("datas", dataone);
    //       return true;
    //     }
    //   }
    //   return true;
    // };
    if (checkPreviousCompleted(this.uniqueVaccineList, index)) {
      this.recordId = this.uniqueVaccineList[index].recordId;
      this.patientdetails = this.uniqueVaccineList[index];
      console.log("this.patientdetails", this.patientdetails);
    } else {
      this.onClickCheckbox(event);
      let msg = `Complete ${datas.vaccine_month.toLowerCase()} vaccinations first.`
      this.showVaccinationReminder(msg, 0);
      return;
    }
    // if (type == '1') {
    //   if (checkPreviousCompleted(this.swipdataone, index)) {
    //     this.recordId = this.swipdataone[index].recordId;
    //     this.patientdetails = this.swipdataone[index];
    //     console.log("this.patientdetails", this.patientdetails);
    //   } else {
    //     this.onClickCheckbox(event);
    //     let msg = `Please complete ${datas.vaccine_month.toLowerCase()} vaccinations first.`
    //     this.showVaccinationReminder(msg, 0);
    //     return;
    //   }
    // } else if (type == "2") {
    //   if (this.swipdataone.every(item => item.is_completed === "1")) {
    //     if (checkPreviousCompleted(this.swipdatatwo, index)) {
    //       this.recordId = this.swipdatatwo[index].recordId;
    //       this.patientdetails = this.swipdatatwo[index];
    //       console.log("this.patientdetails", this.patientdetails);
    //     } else {
    //       this.onClickCheckbox(event);
    //       let msg = `Please complete ${datas.vaccine_month.toLowerCase()} vaccinations first.`
    //       this.showVaccinationReminder(msg, 0);
    //       return;
    //     }
    //   } else {
    //     if (checkPreviousCompleteds(this.swipdataone, 4)) {
    //       this.onClickCheckbox(event);
    //       let msg = `Please complete ${dataone.vaccine_month.toLowerCase()} vaccinations first.`
    //       this.showVaccinationReminder(msg, 0);
    //     } else {
    //       this.onClickCheckbox(event);
    //       alert("Please complete all vaccinations in the first set before proceeding to the second set.");
    //     }
    //     return;
    //   }
    // }
    console.log("this.recordId", this.recordId);
    if (this.patientdetails.accepte_vaccine == "1") {
      let apiData = {
        "isComplete": 1,
        "recordId": this.recordId
      }
      this.service.postRequestGndrl("Patient/updateInfantListDetails", apiData).subscribe(res => {
        console.log(res, "res");
        try {
          if(res.status == 1 && res.msg == 'success'){
            this.getInfantDetails();
            this.showVaccinationReminder(this.patientdetails, 1);
          }
        } catch (error) {
          console.log("error",error);
        }
      })
    } 
    else 
    {
      this.onClickCheckbox(event);
      let msg = `Your vaccinations date is  ${moment(this.patientdetails.date_of_injection).format('DD-MMM-YYYY')}.`
      this.showVaccinationReminder(msg, 0);

    }
  }


  onClickCheckbox(event: any) {
    // Prevent default checkbox behavior
    event.preventDefault();
  }
  dateformat(date) {
    let dates = moment(date).format('DD-MMM-YY');
    return dates;
  }
  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    var Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(":");
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        // var ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        // if (this.addCall.selectedLanguage == 'en') {
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      // } else if(this.addCall.selectedLanguage == 'ea') {
      //   let dateCall = new Date(dateTime);
      //   this.months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
      //     "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
      //   ];
      //   var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
      //   var arDate = dateCall.getDate() + '-' + this.months[dateCall.getMonth()] + '-' + dateCall.getFullYear();
      //   return arDate;
      // }
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else if (this.addCall.selectedLanguage == 'ea') {
          let dateCall = new Date(dateTime);
          var months = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          var arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
      //return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");

    }
  }
  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }
  async showVaccinationReminder(patientdetails, status) {
    let popup = await this.modalCtrl.create({
      component: VaccinepopupPage,
      componentProps: {
        'data': patientdetails,
        'VaccinationSuccessstatus': status,
        'gender': this.gender,
      },
      cssClass: 'class_alert'
    })
    popup.onDidDismiss().then((data) => {
      try {
        if (data.data) {
          console.log(data.data, 'datas');
          let apiData = {
            "isComplete": 2,
            "recordId": data.data
          }
          this.service.postRequestGndrl("Patient/updateInfantListDetails", apiData).subscribe(res => {
            console.log(res, "okres");
          })
        }
      } catch (error) {
        console.log("error", error);
      }

    });
    await popup.present();
  }

  getClassForYearId(year_id: string) {
    switch (year_id) {
      case '2': return 'class-for-2';
      case '3': return 'class-for-3';
      case '4': return 'class-for-4';
      case '5': return 'class-for-5';
      case '6': return 'class-for-6';
      case '7': return 'class-for-7';
      case '8': return 'class-for-8';
      case '9': return 'class-for-9';
      case '10': return 'class-for-10';
      case '11': return 'class-for-11';
      case '12': return 'class-for-12';
      default: return '';
    }
  }

}
